<div class="top">
  <h2>Desgaste de Tubulares</h2>
</div>
<table mat-table [dataSource]="tubingWearReports" class="tubing-wear-table handover-data-table">
  <ng-container matColumnDef="tubing">
    <mat-header-cell *matHeaderCellDef> Tubular </mat-header-cell>

    <mat-cell *matCellDef="let report; let i = index">
      <mat-form-field class="selector" appearance="fill">
        <mat-select [disabled]="true" [(ngModel)]="report.tubing.tubingId" (selectionChange)="enableRow(i)">
          <mat-option>Seleccione elemento</mat-option>
          <mat-option *ngFor="let tubing of tubings" [value]="tubing.tubingId">
            {{tubing.name}}
          </mat-option>
        </mat-select>
        </mat-form-field>
    </mat-cell>

    <mat-footer-cell *matFooterCellDef>
      <mat-form-field class="selector" appearance="fill">
        <mat-label>Seleccionar</mat-label>
        <mat-select (selectionChange)="enableRow(null)" [(ngModel)]="nextTubingWearReport.tubing">
          <mat-option>Seleccione elemento</mat-option>
          <mat-option *ngFor="let tubing of availableTubings" [value]="tubing">
            {{tubing.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="maximumPenetration">
    <mat-header-cell *matHeaderCellDef> Máxima Penetración<br>[% de Espesor nominal] </mat-header-cell>

    <mat-cell *matCellDef="let report; let i = index">
      <mat-form-field>
        <input [disabled]="readOnlyContent || report.automated" matInput digitOnly pattern="^\d+(\.\d{1,2})?$" [decimal]="true"
          inputmode="numeric" [min]="0" [max]="100" [(ngModel)]="report.maximumPenetration"
          (change)="enableRow(i)" (keyup)="enableRow(i)" />
      </mat-form-field>
    </mat-cell>

    <mat-footer-cell *matFooterCellDef>
      <mat-form-field *ngIf="nextTubingWearReportIsEnabled">
        <mat-label>Indique valor</mat-label>
        <input matInput digitOnly pattern="^\d+(\.\d{1,2})?$" [decimal]="true" inputmode="numeric"
          [min]="0" [max]="100" [(ngModel)]="nextTubingWearReport.maximumPenetration"
          (change)="enableRow(null); onSectionTouched('wellIntegrity')"
          (keyup)="enableRow(null); onSectionTouched('wellIntegrity')" />
        <mat-hint class="alert">
          Dato obligatorio.
        </mat-hint>
      </mat-form-field>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="maximumPenetrationDepth">
    <mat-header-cell *matHeaderCellDef> Profundidad Estimada de<br>Máxima Penetración [m] </mat-header-cell>

    <mat-cell *matCellDef="let report; let i = index">
      <mat-form-field>
        <input [disabled]="readOnlyContent || report.automated" matInput digitOnly inputmode="numeric" [min]="1" [(ngModel)]="report.maximumPenetrationDepth"
          (change)="enableRow(i); onSectionTouched('wellIntegrity')" (keyup)="enableRow(i); onSectionTouched('wellIntegrity')" />
      </mat-form-field>
    </mat-cell>

    <mat-footer-cell *matFooterCellDef>
      <mat-form-field *ngIf="nextTubingWearReportIsEnabled">
        <mat-label>Indique valor</mat-label>
        <input matInput digitOnly inputmode="numeric" [min]="1" [(ngModel)]="nextTubingWearReport.maximumPenetrationDepth"
          (change)="enableRow(null); onSectionTouched('wellIntegrity')"
          (keyup)="enableRow(null); onSectionTouched('wellIntegrity')" />
        <mat-hint class="alert">
          Dato obligatorio.
        </mat-hint>
      </mat-form-field>
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>

    <mat-cell *matCellDef="let report; let i = index" [ngClass]="'mat-column-save'">
      <span class="row-buttons">
        <button mat-mini-fab class="comment-ho-icon"
          (click)="openComments(tubingWearReports[i], i, $event, readOnlyContent); onSectionTouched('wellIntegrity')">
          <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
          <div class="circle-comments" *ngIf="tubingWearReports[i].comments"></div>
          <span class = "comment">Comentar</span>
        </button>
      </span>
      <button *ngIf="!readOnlyContent" mat-mini-fab (click)="save(report);" class="save-ho-icon" [disabled]="!report.enableSave">
        <mat-icon class="material-icons-outlined">save</mat-icon>
      </button>
      <button *ngIf="!readOnlyContent && !report.automated" mat-mini-fab (click)="deleteReport(report);" class="delete-ho-icon">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </mat-cell>

    <mat-footer-cell *matFooterCellDef>
      <span class="row-buttons">
        <button [disabled]="!nextTubingWearReportIsEnabled" mat-mini-fab
          (click)="openComments(nextTubingWearReport, null, $event, readOnlyContent); onSectionTouched('wellIntegrity')"
          class="comment-ho-icon">
          <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
          <div class="circle-comments" *ngIf="nextTubingWearReport.comments"></div>
          <span class = "comment">Comentar</span>
        </button>
      </span>
      <span matTooltip="Indique detalle de tubular en comentarios"
          [matTooltipDisabled]="!nextTubingWearReport.tubing || nextTubingWearReport.tubing.tubingId != idOtherTubings">
        <button mat-mini-fab (click)="save(nextTubingWearReport);" class="save-ho-icon" [disabled]="!nextTubingWearReport.enableSave">
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
      </span>
    </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  <ng-container *ngIf="!readOnlyContent">
    <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
  </ng-container>
</table>

